<template>
  <div class="mobile-share">
    <social-sharing
      :url='url'
      title="Dignity Funerals - We all need to plan for life's biggest moments, but at what age do these events actually happen? Discover more with our Life's Moments tool."
      description="We all need to plan for life's biggest moments, but at what age do these events actually happen? Discover more with our Life's Moments tool."
      quote="Dignity Funerals - We all need to plan for life's biggest moments, but at what age do these events actually happen? Discover more with our Life's Moments tool."
      inline-template
    >
      <div class="sharing">

        <network network="twitter">
          <simple-svg
            :filepath="'/static/svg/twitter-mobile.svg'"
            :width="'50px'"
            :height="'50px'"
          />
        </network>
        <network network="facebook">
          <simple-svg
            :filepath="'/static/svg/facebook-mobile.svg'"
            :width="'50px'"
            :height="'50px'"
          />
        </network>
      </div>
    </social-sharing>
  </div>
</template>

<script>
export default {
  name: 'MobileSocial',
  data () {
    return {
      url: window.location.href
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

@import '../styles/core/vars.scss';
@import '../styles/core/mixins.scss';

.mobile-share {
  position: fixed;
  bottom: 100px;
  right: 20px;

  @include respond-to('medium') {
    display: none;
  }

  .sharing {
    cursor: pointer;

    /deep/ svg {
      fill: $c-white;
      opacity: 0.5;
      transition: opacity 0.2s ease-in-out;
    }

    /deep/ span {
      &:hover /deep/ svg {
        opacity: 1;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/MobileShare.vue